module.exports = __webpack_public_path__ + "static/img/COVER-11.7ae499f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/COVER-11.png
// module id = Uafg
// module chunks = 31